import { render, staticRenderFns } from "./DigitalReferenceInfoCards.vue?vue&type=template&id=5651b39a&scoped=true"
import script from "./DigitalReferenceInfoCards.vue?vue&type=script&lang=ts"
export * from "./DigitalReferenceInfoCards.vue?vue&type=script&lang=ts"
import style0 from "./DigitalReferenceInfoCards.vue?vue&type=style&index=0&id=5651b39a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5651b39a",
  null
  
)

export default component.exports